import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "globe",
  "use": "globe-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"globe\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 108 1a7 7 0 000 14z\" /><path d=\"M10.934 1.643A.98.98 0 0111 2v2a1 1 0 01-1 1H7.996C8 5.03 8 5.059 8 5.088V5a1 1 0 01-1 1H4l1 4h5a1 1 0 011 1v1a1 1 0 011 1v.745a7.021 7.021 0 01-5.567 1.079A.999.999 0 016 14l1-1S1.062 7.615 1.062 7.062a7.001 7.001 0 019.872-5.42z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol